module.exports = __webpack_public_path__ + "static/media/NAFIL_logo.7177dd6c.svg";